// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._LmZE{margin-bottom:8px}.AiKaO .MZGxB{opacity:0;transition:opacity .15s ease-in-out}.AiKaO .MZGxB:focus-visible{opacity:1}.AiKaO:hover .MZGxB{opacity:1}.AiKaO.dKdGg .MZGxB{opacity:1;transition:none}.nl9Fp{display:flex;align-items:center;justify-content:flex-end;gap:12px;width:100%}.PuIeT{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;max-width:100%}.iIfgV{min-width:0;max-width:100%;overflow:hidden}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `_LmZE`,
	"row": `AiKaO`,
	"editPill": `MZGxB`,
	"rowMobile": `dKdGg`,
	"statusCell": `nl9Fp`,
	"recipientLabel": `PuIeT`,
	"mobileEventCell": `iIfgV`
};
export default ___CSS_LOADER_EXPORT___;
